import { config } from "@/config"
import { TCSAPIResponse } from "@/types/types"
import axios, { AxiosError, AxiosResponse } from "axios"
import { formatResponse } from "./helpers/formatResponse"
import { WorkflowExecutionDetailsResp, WorkflowExecutionsResp } from "@/types/workflowHistory"

export const WorkflowExecutionAPI = {
  getWorkflowExecutions: async (token: string, workflowId: string) => {
    try {
      const resp: AxiosResponse<TCSAPIResponse> = await axios({
        method: 'GET',
        url: `${config.apiUrl}/v1/workflows/${workflowId}/executions`,
        headers: {
          Authorization: `Bearer ${token}`
        },
      })

      return formatResponse<WorkflowExecutionsResp>(resp.data, null)
    } catch (error) {
      console.log('Error: ', error instanceof Error ? error.message : error)
      return formatResponse<WorkflowExecutionsResp>(null, error as AxiosError)
    }
  },

  getExecutionDetails: async (token: string, executionId: string) => {
    try {
      const resp: AxiosResponse<TCSAPIResponse> = await axios({
        method: 'GET',
        url: `${config.apiUrl}/v2/workflows/executions/${executionId}`,
        headers: {
          Authorization: `Bearer ${token}`
        },
      })

      return formatResponse<WorkflowExecutionDetailsResp>(resp.data, null)
    } catch (error) {
      console.log('Error: ', error instanceof Error ? error.message : error)
      return formatResponse<WorkflowExecutionDetailsResp>(null, error as AxiosError)
    }
  },

  reRunByExecutionId: async (token: string, executionId: string) => {
    try {
      const resp: AxiosResponse<TCSAPIResponse> = await axios({
        method: 'POST',
        url: `${config.apiUrl}/v1/workflows/workflow-execution/${executionId}/rerun`,
        headers: {
          Authorization: `Bearer ${token}`
        },
      })

      return formatResponse<TCSAPIResponse>(resp.data, null)
    } catch (error) {
      console.log('Error: ', error instanceof Error ? error.message : error)
      return formatResponse<TCSAPIResponse>(null, error as AxiosError)
    }
  },

  reRunStep: async (token: string, stepId: string, shouldRunAllFollowingSteps: boolean) => {
    try {
      const resp: AxiosResponse<TCSAPIResponse> = await axios({
        method: 'POST',
        url: `${config.apiUrl}/v2/workflows/workflow-execution/step/${stepId}/rerun`,
        headers: {
          Authorization: `Bearer ${token}`
        },
        data: {
          cascadeDownstream: shouldRunAllFollowingSteps
        }
      })

      return { data: resp.data, err: undefined }
    } catch (error) {
      console.log('Error: ', error instanceof Error ? error.message : error)
      return { data: undefined, err: 'Unable to run the step. Please try again later.' }
    }
  },
}
